<template>
  <div class="modal-backdrop">
    <div class="modal">
      <div class="modal-header">
        <h3>服务区域</h3>
      </div>
      <div class="modal-body">
        <div class="box">
          <img class="positionImg" src="@/assets/images/position.png" alt="" />
          <p class="one">请正确选择您企业注册所在地</p>
          <p class="two">以便更好地使用融资服务</p>
          <p class="showPosition">
            当前定位：
            <span class="currentPosition">{{ address }}</span>
          </p>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn-close" @click="closeSelf">
          切换服务区
        </button>
        <button type="button" class="btn-confirm" @click="confirm">确定</button>
      </div>
    </div>
  </div>
</template>

<style>
.modal-backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal {
  background-color: #fff;
  box-shadow: 2px 2px 20px 1px;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  width: 300px;
  height: 500px;
}
.modal-header {
  height: 50px;
  text-align: center;
  color: #313131;
  justify-content: space-between;
  display: flex;
}
.modal-header h3 {
  width: 100%;
  text-align: center;
  font-size: 18px;
}
.modal-footer {
  border-top: 1px solid #eee;
  justify-content: flex-end;
  box-sizing: border-box;
  height: 48px;
  display: flex;
  margin-top: 12px;
}
.modal-footer button {
  width: 50%;
  float: left;
  height: 50px;
  border-radius: none !important;
}
.modal-body {
  position: relative;
  padding: 0px 10px;
}
.btn-close,
.btn-confirm {
  margin-left: 16px;
  width: 56px;
  height: 36px;
  border: none;
  cursor: pointer;
  border: none;
  background: none;
  height: 100%;
  margin: 0;
  font-weight: bold;
  font-size:16px;
}
.btn-close {
  color: #999;
  border-right: 1px solid #eee;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.btn-confirm {
  color: #f5514a;
}
.box {
  position: relative;
  padding: 0 10px;
}
.box .positionImg {
  width: 100%;
  height: 380px;
}
.box p {
  font-size: 18px;
  color: #ffffff;
  letter-spacing: 0;
  box-sizing: border-box;
  text-align: center;
  font-weight: bold;
}
.box .one {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 30px auto;
}
.box .two {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 54px auto;
}
.showPosition {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: 100px auto;
  width: 156px;
  height: 33px;
  background-color: #fc4648;
  border-radius: 37.5px;
  line-height: 33px;
  font-size: 18px;
  box-sizing: border-box;
}
</style>

<script>
// import bus from '../utils/bus'
export default {
  name: 'Modal',
  data() {
    return {};
  },
  props: {
    address: String,
    districtId: String,
  },
  methods: {
    closeSelf() {
      console.log(this.address, this.districtId);
      this.$router.push({
        path: '/supermarket/v2/selectProvince',
        query: { address: this.address, adcode: this.districtId },
      });
    },
    confirm() {
      this.$emit('closeme');
    },
  },
};
</script>
